import React from 'react';
import './chapters.scss';
import InlinePhotos from '../InlinePhotos/InlinePhotos';
import inlineD from '../../assets/image2-l.jpg';
import inlineM from '../../assets/image2-s.jpg';
import Quote from '../Quote/Quote';
function Chapter5() {
  const inlinePhotoData = {
    srcD: inlineD,
    srcM: inlineM
  };
  const quoteData = {
    copy: '“The car will be an entirely new living space where we work, play, and enjoy spending time with friends and family—a technology-rich dynamic environment.”',
    author: 'Jack Weast',
    title: 'VP & General Manager, Intel Automotive'
  };
  return (
    <section className="chapters">
      <InlinePhotos data={inlinePhotoData} />
      <div className="chapters__copy">
        <h3>Ready for the Road Ahead</h3>
        <p>
          Today, Intel’s semiconductors can already be found in over 50 million cars. To support the
          increased demand for automotive semiconductors, Intel has invested $60 billion in new
          fabrication sites in New Albany, Ohio (USA) and Magdeburg, Germany (EU). With these
          facilities online, automakers will not only have more resilient, globally balanced supply
          chains, but they will also have the flexibility to source semiconductors from the most
          convenient locations. This reduces the risk of shipping delays and emissions, as
          semiconductors are shipped locally rather than across oceans.
        </p>

        <p>
          The new Intel Foundry Services (IFS) model is also leveraging decades of leadership and
          experience to help automakers do something unique by integrating chiplets from different
          semiconductor factories into a single product. To illustrate how IFS can deliver bespoke,
          cost-saving solutions and protect an automaker’s unique IP, Weast offers the example of an
          automaker that has developed unique AI capabilities:
        </p>
        <p>
          “To develop a fully custom SoC would be prohibitively expensive… but if automakers put
          that AI IP on a chiplet, Intel Foundry Services can integrate that chiplet—no matter
          whereby whom or on what node it is manufactured—with an Intel roadmap product delivering a
          hybrid custom solution.” The implications of IFS are huge for both automakers and the
          driving public who want to take part in a more sustainable, safer, and smarter mobility
          future.
        </p>
        <p>
          For Weast, that future looks bright: “The car will be an entirely new living space where
          we work, play, and enjoy spending time with friends and family—a technology-rich dynamic
          environment that features the latest and greatest technologies the semiconductor industry
          can bring.”
        </p>
        <Quote data={quoteData} />
      </div>
    </section>
  );
}

export default Chapter5;
